import { useAppFeatures } from "@/hooks/useAppFeatures";

import LegacySsoCallbackPage from "./LegacyCallback";
import LokasiSsoCallbackPage from "./LokasiSsoCallback";

/**
 * `/sso/callback` serves both SSO implementations, since each IdP has a single
 * redirect URI registered for this app.
 *
 * When LOKASI internal SSO is on it is the only reachable path — the guards hand
 * off to the LOKASI IdP before the legacy flow can ever be started — so the flag
 * alone is enough to pick the right handler.
 */
const SsoCallbackPage = () => {
  const { isLokasiSsoAuthEnabled } = useAppFeatures();

  return isLokasiSsoAuthEnabled ? (
    <LokasiSsoCallbackPage />
  ) : (
    <LegacySsoCallbackPage />
  );
};

export default SsoCallbackPage;
